export class GameTitle extends Phaser.GameObjects.Container {

    private blackPuck: Phaser.GameObjects.Image;
    private whitePuck: Phaser.GameObjects.Image;
    private fire: Phaser.GameObjects.Image;
    private f: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.y = -275;

        this.f = 75;

        this.fire = new Phaser.GameObjects.Image(this.scene, 158, -14, "texture_atlas_1", "logo_fire");
        this.fire.setScale(.7);
        this.add(this.fire);

        this.blackPuck = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_black_puck");
        this.add(this.blackPuck);

        this.whitePuck = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_white_puck");
        this.add(this.whitePuck);

        const logoCarrom = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_carrom");
        this.add(logoCarrom);

        const logoHero = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_hero");
        this.add(logoHero);
    }

    public update(): void {

        this.f ++;

        if (this.f === 100) {
            this.f = 0;
            this.animatePucks();
        }
    }

    private animatePucks(): void {

        this.scene.tweens.add({
            targets: this.whitePuck,
            x: -10,
            y: -12,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600,
            onComplete: function(): void {
                this.whitePuck.x = 0;
                this.whitePuck.y = 0;
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this.blackPuck,
            x: 10,
            y: 6,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600,
            onComplete: function(): void {
                this.blackPuck.x = 0;
                this.blackPuck.y = 0;

                this.scene.tweens.add({
                    targets: this.fire,
                    scaleX: 1,
                    scaleY: 1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 90,
                    onComplete: function(): void {
                        this.scene.tweens.add({
                            targets: this.fire,
                            scaleX: .7,
                            scaleY: .7,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 950
                        });
                    },
                    onCompleteScope: this
                });

            },
            onCompleteScope: this
        });
    }
}
